import { createAsyncThunk } from "@reduxjs/toolkit";
import { showToast } from "../toast/reducer";
import { getAllUsers, bulkDeleteUsers as bulkDeleteUsersAPI, getUserHistory, getUserDetails, createAdminUser } from "../../helpers/apis";

export const fetchUsers = createAsyncThunk(
  "users/fetchUsers",
  async (params, thunkAPI) => {
    try {
      // Convert params to query format expected by backend
      const queryParams = {
        page: params.page || params.currentPage || 1,
        limit: params.limit || params.perPage || 10,
        search: params.search || "",
        loginType: params.loginType || "",
        sort: params.order || params.sort || "",
      };

      const response = await getAllUsers(queryParams);

      if (!response.error) {
        return response;
      } else {
        thunkAPI.dispatch(showToast({ type: "error", msg: response.msg }));
        return thunkAPI.rejectWithValue(response.msg);
      }
    } catch (error) {
      const errorMsg = error.message || "Failed to fetch users";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

export const bulkDeleteUsers = createAsyncThunk(
  "users/bulkDeleteUsers",
  async ({ userIds }, thunkAPI) => {
    try {
      const response = await bulkDeleteUsersAPI({ userIds });

      if (!response.error) {
        thunkAPI.dispatch(showToast({ type: "success", msg: response.msg }));
        // Refetch users after deletion
        const currentState = thunkAPI.getState().Users;
        const currentParams = {
          page: currentState.pagination.page,
          limit: currentState.pagination.limit,
        };
        thunkAPI.dispatch(fetchUsers(currentParams));
        return response;
      } else {
        thunkAPI.dispatch(showToast({ type: "error", msg: response.msg }));
        return thunkAPI.rejectWithValue(response.msg);
      }
    } catch (error) {
      const errorMsg = error.message || "Failed to delete users";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

export const fetchUserHistory = createAsyncThunk(
  "users/fetchUserHistory",
  async ({ userId, params = {} }, thunkAPI) => {
    try {
      const response = await getUserHistory(userId, params);

      if (!response.error) {
        return response;
      } else {
        thunkAPI.dispatch(showToast({ type: "error", msg: response.msg }));
        return thunkAPI.rejectWithValue(response.msg);
      }
    } catch (error) {
      const errorMsg = error.message || "Failed to fetch user history";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

export const fetchUserDetails = createAsyncThunk(
  "users/fetchUserDetails",
  async (userId, thunkAPI) => {
    try {
      const response = await getUserDetails(userId);

      if (!response.error) {
        return response;
      } else {
        thunkAPI.dispatch(showToast({ type: "error", msg: response.msg }));
        return thunkAPI.rejectWithValue(response.msg);
      }
    } catch (error) {
      const errorMsg = error.message || "Failed to fetch user details";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);


export const addNewUser = createAsyncThunk(
  "users/addNewUser",
  async (user, thunkAPI) => {
    try {
      const response = await createAdminUser(user);

      if (!response.error) {
        thunkAPI.dispatch(showToast({ type: "success", msg: "User Added Successfully" }));
        return response;
      } else {
        thunkAPI.dispatch(showToast({ type: "error", msg: response.msg }));
        return thunkAPI.rejectWithValue(response.msg);
      }
    } catch (error) {
      const errorMsg = error.message || "Failed to add user";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);
